import { apiProxyRequest } from "Api/apiProxyRequest";

import type { AddIntegrationParams, AddIntegrationResponse } from "./types";

export const addIntegrationRequest = ({
  projectId,
  data
}: AddIntegrationParams) =>
  apiProxyRequest<AddIntegrationResponse>(
    `/projects/${projectId}/integrations`,
    "POST",
    data
  );
